import type { LandingPageHtmlEmbedBlock } from "@forento/core/models/landing"

type Props = {
	content: LandingPageHtmlEmbedBlock["content"]
	showPlaceholder?: boolean
}

export default function LandingHtmlEmbed({ content, showPlaceholder = false }: Props) {
	if (!content.html.trim() && !showPlaceholder) return null

	return (
		<section className="px-6 pt-16 pb-0 sm:pt-20 lg:px-8">
			<div className="mx-auto max-w-7xl overflow-hidden">
				{content.html.trim() ? (
					<iframe
						title="Custom HTML embed"
						className="block w-full border-0"
						style={{ height: content.height }}
						// Never allow same-origin access: creator scripts must stay isolated from the host page.
						sandbox="allow-scripts allow-forms allow-popups"
						referrerPolicy="no-referrer"
						srcDoc={content.html}
					/>
				) : (
					<div
						className="border-landing-border bg-landing-surface-muted text-landing-foreground-muted flex items-center justify-center rounded-lg border p-8"
						style={{ height: content.height }}
					>
						Paste your embed code to display a form or widget.
					</div>
				)}
			</div>
		</section>
	)
}
